const specialRegex = /[!@&/\\#,+()$~%.'":*?<>{}]/g;
const emojiRegex = /[\u{1F000}-\u{1F9FF}]/gu;

/** format to url word */
export const kepQueryFormat = (query: string) => {
  if (!query) {
    return '';
  }

  const filterCharWord = query.replace(specialRegex, '');
  const filterEmojiWord = filterCharWord.replace(emojiRegex, '');
  const filterSpaceWord = filterEmojiWord.replace(/\s+/g, ' ');
  const lowerCaseWord = filterSpaceWord.replace(/[A-Z]/g, (char) => char.toLowerCase());

  return lowerCaseWord.trim();
};
